import FirebaseAnalytics from "./FirebaseAnalytics";
import OKSpinAnalytics from "./OKSpinAnalytics";
import SelfBuildWebCount from "./SelfBuildWebCount";
import EagllwinAnalytics from "./EagllwinAnalytics";
import { SendAdjustWebEvent, BindAdjustWebUser } from "./AdjustWebAnalytics";
const SendEventToAll = (event, data, sendSelfBuildOnce) => {
  const originalEvent = event;
  if (!data) {
    data = {};
  }
  EagllwinAnalytics.GetInstance().SendEvent(event, data);
  //EagllwinAnalytics归因要把游客注册和账号注册区分出来
  if (event == "register2") {
    event = "register"
  }
  //matomo
  if (window._paq && window._paq.push) {
    if (typeof data == "object" && Object.keys(data).length > 0) {
      for (let key in data) {
        window._paq.push(["trackEvent", event, event, key, data[key]]);
      }
    } else {
      window._paq.push(["trackEvent", event, event]);
    }
  }
  //GA
  if (window.gtag) {
    window.gtag("event", event, data);
  }
  //Firebase
  if (FirebaseAnalytics.instance) {
    FirebaseAnalytics.instance.SendEvent(event, data);
  }

  //其他的一些统计
  if (OKSpinAnalytics.instance) {
    OKSpinAnalytics.instance.SendEvent(event, data);
  }
  if (sendSelfBuildOnce) {
    SelfBuildWebCount.GetInstance().SendEventOnce(event, data);
  } else {
    SelfBuildWebCount.GetInstance().SendEvent(event, data);
  }
  //JSBridge: AF or Adjust
  SendAdjustWebEvent(originalEvent, data);
  if (window.JSBridge && window.JSBridge.SendEvent) {
    window.JSBridge.SendEvent(event, JSON.stringify(data));
  }
};

export const SendEvent = (event, data) => {
  SendEventToAll(event, data, true);
};

export const SendEventEveryTime = (event, data) => {
  console.error("event:", event, "data:", data)
  SendEventToAll(event, data, false);
};

export const BindUser = (rid) => {
  BindAdjustWebUser(rid);
  console.log("BindUser", rid);
  if (window.JSBridge && window.JSBridge.SetRid) {
    console.log("SetRid", rid);
    window.JSBridge.SetRid(rid);
  }
};
